//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './NotificationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetNotificationQueryParameters = {
  language?: string | undefined ;
  types?: Types.NotificationType[] | undefined ;
  offset?: number | undefined ;
  limit?: number | undefined ;
}

export function getUrl(language?: string | undefined, types?: Types.NotificationType[] | undefined, offset?: number | undefined, limit?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/notification?";
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "Language=" + encodeURIComponent("" + language) + "&";
if (types === null)
    throw new Error("The parameter 'types' cannot be null.");
else if (types !== undefined)
    types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
if (offset === null)
    throw new Error("The parameter 'offset' cannot be null.");
else if (offset !== undefined)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit === null)
    throw new Error("The parameter 'limit' cannot be null.");
else if (limit !== undefined)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.GetNotificationsResponseDto[], unknown, Types.GetNotificationsResponseDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetNotificationsResponseDto[], unknown, Types.GetNotificationsResponseDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetNotificationQueryParameters): QueryKey;
export function getQueryKey(language?: string | undefined, types?: Types.NotificationType[] | undefined, offset?: number | undefined, limit?: number | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { language, types, offset, limit,  } = params[0] as GetNotificationQueryParameters;

    return trimArrayEnd([
        'NotificationClient',
        'get',
        language as any,
        types as any,
        offset as any,
        limit as any,
      ]);
  } else {
    return trimArrayEnd([
        'NotificationClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as Types.NotificationType[] | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as number | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.GetNotificationsResponseDto[], TError = unknown>(dto: GetNotificationQueryParameters, options?: Omit<UseQueryOptions<Types.GetNotificationsResponseDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param language (optional) User's language
 * @param types (optional) Types of notifications to include. An empty list means all types.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 */
export function useGetQuery<TSelectData = Types.GetNotificationsResponseDto[], TError = unknown>(language?: string | undefined, types?: Types.NotificationType[] | undefined, offset?: number | undefined, limit?: number | undefined, options?: Omit<UseQueryOptions<Types.GetNotificationsResponseDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.GetNotificationsResponseDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetNotificationsResponseDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let language: any = undefined;
  let types: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ language, types, offset, limit,  } = params[0] as GetNotificationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [language, types, offset, limit, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetNotificationsResponseDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(language, types, offset, limit),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetNotificationsResponseDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param language (optional) User's language
 * @param types (optional) Types of notifications to include. An empty list means all types.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.GetNotificationsResponseDto[] | undefined) => Types.GetNotificationsResponseDto[], language?: string | undefined, types?: Types.NotificationType[] | undefined, offset?: number | undefined, limit?: number | undefined) {
  queryClient.setQueryData(getQueryKey(language, types, offset, limit),
    updater
  );
}

/**
 * Gets data.
 * @param language (optional) User's language
 * @param types (optional) Types of notifications to include. An empty list means all types.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetNotificationsResponseDto[] | undefined) => Types.GetNotificationsResponseDto[]) {
  queryClient.setQueryData(queryKey, updater);
}